import { Box } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { ProductUpdatesProductUpdateModule } from 'generated/resources/graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

export type HeaderProps = {
  title: string
  shortDescription: string
  isAlreadyReleased: boolean
  releaseDate: string
  authorName: string
  productModule: ProductUpdatesProductUpdateModule
}

const Header = ({
  title,
  isAlreadyReleased,
  releaseDate,
  authorName,
  productModule,
}: HeaderProps) => {
  return (
    <Box>
      <Box width="fit-content" paddingX="s16">
        <F0TagRaw text={productModule?.name || '-'} />
      </Box>
      <Box className="max-w-full p-0">
        <ResourceHeader
          title={title}
          status={{
            label: i18n.t('product_updates.detail_page.status'),
            text: isAlreadyReleased
              ? i18n.t('product_updates.detail_page.released')
              : i18n.t('product_updates.coming_soon'),
            variant: isAlreadyReleased ? 'positive' : 'warning',
          }}
          metadata={[
            {
              label: i18n.t('product_updates.detail_page.release_date'),
              value: {
                content: moment(releaseDate).format('DD/MM/YYYY'),
                type: 'text',
              },
            },
            {
              label: i18n.t('product_updates.detail_page.written_by'),
              value: {
                text: authorName || '',
                type: 'avatar',
                variant: {
                  firstName: authorName?.split(' ')[0] || '',
                  lastName: authorName?.split(' ')[1] || '',
                  type: 'person',
                },
              },
            },
          ]}
        />
      </Box>
    </Box>
  )
}

export default Header
